export const personFilterLabels = {
  searchPlaceholder: 'Search by name...',
  youSuffix: '(You)',
} as const
